 
export enum Language {
  English = "English Speaking",
  Hindi = "Hindi Speaking",
  Urdu = "Urdu Speaking",
  Spanish = "Spanish Speaking",
  Turkish = "Turki Speaking",
  Chinese = "China Speaking",
  Arabic = "Arabic Speaking",
  Bangla = "Bangla Speaking",
  Hebrew = "Hibru Speaking",
}

// Define a reusable Instructor type
export interface Instructor {
  readonly name: string;
  readonly image: string;
  readonly role: string;
}

// Main Course type
export interface Course {
  readonly icon?: string;
  readonly title: string;
  readonly description: string;
  readonly instructor: Instructor;
}

// Strictly typed data
// Define course type (you should already have this)


// Sample data
export const coursesData: Course[] = [
  {
    title: "B.Sc - Medical Laboratory Technology",
    description: "Duration: 3 yrs | Eligibility: 12th science",
    instructor: {
      name: "Dr. Ayesha Khan",
      role: "Instructor",
      image: "/images/users/user1.webp"
    }
  },
  {
    title: "B.Sc - Radiology and Imaging",
    description: "Duration: 3 yrs | Eligibility: 12th science",
    instructor: {
      name: "Dr. Ramesh Patel",
      role: "Instructor",
      image: "/images/users/user2.webp"
    }
  },
  {
    title: "B.Sc - Software Development",
    description: "Duration: 3 yrs | Eligibility: 12th any stream",
    instructor: {
      name: "Prof. Neha Sharma",
      role: "Instructor",
      image: "/images/users/user3.webp"
    }
  },
  {
    title: "B.Sc - AI and Machine Learning",
    description: "Duration: 3 yrs | Eligibility: 12th any stream",
    instructor: {
      name: "Dr. David Lee",
      role: "Instructor",
      image: "/images/users/user1.webp"
    }
  },
  {
    title: "Diploma - Medical Lab Technology",
    description: "Duration: 2 yrs | Eligibility: 10th, 12th any stream",
    instructor: {
      name: "Dr. Anjali Mehra",
      role: "Instructor",
      image: "/images/users/user1.webp"
    }
  },
  {
    title: "Diploma - Radiation Technology",
    description: "Duration: 2 yrs | Eligibility: 10th, 12th any stream",
    instructor: {
      name: "Dr. Mohan Rao",
      role: "Instructor",
      image: "/images/users/user6.webp"
    }
  },
  {
    title: "Diploma - Physiotherapy",
    description: "Duration: 2 yrs | Eligibility: 12th science stream",
    instructor: {
      name: "Dr. Priya Kulkarni",
      role: "Instructor",
      image: "/images/users/user7.webp"
    }
  },
  {
    title: "Diploma - Sanitary Inspector",
    description: "Duration: 1 yr | Eligibility: 10th, 12th any stream",
    instructor: {
      name: "Dr. Naveen Joshi",
      role: "Instructor",
      image: "/images/users/user8.webp"
    }
  },
  {
    title: "General Nursing - Mid Wifery",
    description: "Duration: 3 yrs | Eligibility: 10th, 12th any stream",
    instructor: {
      name: "Dr. Asha Thomas",
      role: "Instructor",
      image: "/images/users/user9.webp"
    }
  },
  {
    title: "Auxiliary Nursing - Mid Wifery",
    description: "Duration: 2 yrs | Eligibility: 12th any stream",
    instructor: {
      name: "Dr. Ravi Mehta",
      role: "Instructor",
      image: "/images/users/user3.webp"
    }
  },
  {
    title: "Post Graduate Diploma - Medical Lab Technology",
    description: "Duration: 18 months | Eligibility: BSc science stream",
    instructor: {
      name: "Dr. Sheetal Kapoor",
      role: "Instructor",
      image: "/images/users/user2.webp"
    }
  },
  {
    title: "Operation Theatre - Technician",
    description: "Duration: 2 yrs | Eligibility: 12th science stream",
    instructor: {
      name: "Dr. Ajay Deshmukh",
      role: "Instructor",
      image: "/images/users/user2.webp"
    }
  },
  {
    title: "Diploma - Pharmacy",
    description: "Duration: 2 yrs | Eligibility: 12th any stream",
    instructor: {
      name: "Dr. Reena Verma",
      role: "Instructor",
      image: "/images/users/user1.webp"
    }
  }
] as const;




// Strictly typed dataset
export const coursesDataThree: Course[] = [
  {
    icon: "/images/icons/english.svg",
    title: Language.English,
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's.",
    instructor: {
      image: "/images/users/user1.jpg",
      name: "Steven James",
      role: "Instructor",
    },
  },
  {
    icon: "/images/icons/hindi.svg",
    title: Language.Hindi,
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's.",
    instructor: {
      image: "/images/users/user1.jpg",
      name: "Steven James",
      role: "Instructor",
    },
  },
  {
    icon: "/images/icons/urdu.svg",
    title: Language.Urdu,
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's.",
    instructor: {
      image: "/images/users/user1.jpg",
      name: "Steven James",
      role: "Instructor",
    },
  },
  {
    icon: "/images/icons/spanish.svg",
    title: Language.Spanish,
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's.",
    instructor: {
      image: "/images/users/user1.jpg",
      name: "Steven James",
      role: "Instructor",
    },
  },
] as const;